import script from "./ExpandCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandCollapse.vue?vue&type=script&setup=true&lang=js"

import "./ExpandCollapse.vue?vue&type=style&index=0&id=2395179e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2395179e"]])

export default __exports__